import { findLastIndex } from 'lodash-es';
import {
  GO_TO_STEP, NEXT_STEP, PREV_STEP, REGISTER_STEP
} from './actions';
import {
  ACTIVE_STEP_IS_COMPLETE, ACTIVE_STEP_NAME, FIRST_STEP_IS_ACTIVE, HIGHEST_UNLOCKED_STEP_INDEX,
  LAST_STEP_IS_ACTIVE
} from './getters';
import {
  MARK_STEP_COMPLETE, MARK_STEP_INCOMPLETE, MARK_STEP_VISITED,
  SET_TRANSITIONING
} from './mutations';
import { ACTIVE_STEP_INDEX, IS_TRANSITIONING, STEPS } from './state';

export default {
  namespaced: true,

  state: () => ({
    [ACTIVE_STEP_INDEX]: 0,
    [STEPS]: [],
    [IS_TRANSITIONING]: true
  }),

  getters: {
    activeStep: (state) => state[STEPS][state[ACTIVE_STEP_INDEX]],

    [ACTIVE_STEP_IS_COMPLETE]: (state, getters) => getters.activeStep?.complete,

    [ACTIVE_STEP_NAME]: (state, getters) => getters.activeStep?.name,

    [FIRST_STEP_IS_ACTIVE]: (state) => state[ACTIVE_STEP_INDEX] === 0,

    [HIGHEST_UNLOCKED_STEP_INDEX]: (state) => Math.min(
      ...[
        state[STEPS].findIndex((s) => !s.complete),
        findLastIndex(state[STEPS], (s) => s.visited)
      ].filter((x) => x >= 0)
    ),

    [LAST_STEP_IS_ACTIVE]: (state) => state[ACTIVE_STEP_INDEX] === state[STEPS].length - 1
  },

  actions: {
    [GO_TO_STEP]: ({ commit, getters, state }, name) => {
      const index = state[STEPS].findIndex((s) => s.name === name);
      if (index < 0 || index > getters[HIGHEST_UNLOCKED_STEP_INDEX]) return;

      commit('setActiveStep', index);
    },

    [NEXT_STEP]: ({ commit, getters }) => {
      if (!getters[LAST_STEP_IS_ACTIVE] && getters.activeStep.complete) {
        commit('incrementActiveStep');
      }
    },

    [PREV_STEP]: ({ commit, getters }) => {
      if (!getters[FIRST_STEP_IS_ACTIVE]) {
        commit('decrementActiveStep');
      }
    },

    [REGISTER_STEP]: ({ commit, state }, name) => {
      if (state[STEPS].find((s) => s.name === name)) {
        throw new Error(`A step named "${name}" has already been added. Steps names must be unique.`);
      }

      commit('registerStep', name);
    }
  },

  mutations: {
    decrementActiveStep: (state) => state[ACTIVE_STEP_INDEX]--,

    incrementActiveStep: (state) => state[ACTIVE_STEP_INDEX]++,

    [MARK_STEP_VISITED]: (state, index) => { state[STEPS][index].visited = true; },

    [MARK_STEP_COMPLETE]: (state, index) => { state[STEPS][index].complete = true; },

    [MARK_STEP_INCOMPLETE]: (state, index) => { state[STEPS][index].complete = false; },

    registerStep: (state, name) => state[STEPS].push({
      name,
      visited: false,
      complete: false
    }),

    setActiveStep: (state, index) => { state[ACTIVE_STEP_INDEX] = index; },

    [SET_TRANSITIONING]: (state, val) => { state[IS_TRANSITIONING] = val; }

  }
};
